import { render, staticRenderFns } from "./lesseeRevenue.vue?vue&type=template&id=64c66a50&scoped=true"
import script from "./lesseeRevenue.vue?vue&type=script&lang=js"
export * from "./lesseeRevenue.vue?vue&type=script&lang=js"
import style0 from "./lesseeRevenue.vue?vue&type=style&index=0&id=64c66a50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c66a50",
  null
  
)

export default component.exports